import { ViewType, ViewObject } from '../base';
import { dataService } from '../../data';
import { AskWaiter } from '../objects/askwaiter';
import { TicketView } from './ticket';

/****************************/
/* CLASS VIEW               */
/****************************/

export class _AskWaiterView extends ViewObject<AskWaiter> {

    /**********************************/
    /* VIEWOBJECT IMPLEMENTATION      */
    /**********************************/

    private get askwaiter(): AskWaiter {
        return this.object;
    }

    constructor(object: AskWaiter, data: dataService){
        super(object, data);
    }

    private RefreshView(targets: string[]): void {
        if (targets.includes('ASKWAITER')){
            this.DoRefreshView();
        }
    }

    override doRegister(): void {
        const weakref = new WeakRef(this);

        for (const _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];

        this._subscriptions.push(
            this.askwaiter.OnRefresh.subscribe((targets: string[]) => {
                const self = weakref.deref();
                if (self){
                    self.RefreshView(targets);
                }
            })
        );
    }

    /**********************************/
    /* ACTIVE CHILDREN INFORMATION    */
    /**********************************/

    get ticket(): TicketView | null {
        return this.alives.get(this.askwaiter.ticket) as TicketView | null;
    }
}

/****************************/
/* PROXY VIEW               */
/****************************/

export type AskWaiterView = ViewType <_AskWaiterView, AskWaiter>;

export function AskWaiterViewProxy(object: AskWaiter, data: dataService): AskWaiterView {
    return new _AskWaiterView(object, data).Proxy as AskWaiterView;
}
